import { lazy } from "react";

const routes = [
  {
    path: "/block-village-mapping",
    element: lazy(() => import("../pages/BlockVillageMapping")),
  },
];

export default routes;
